import { Order } from '../../../../ts/helpers/Order';
import { OrderKeys } from '../../../../ts/models/OrderKeys';
import { SortOptions } from '../../../../ts/models/sort/CommonSortOptions';
import { OptionsDictionary } from '../../../../ts/models/sort/SortOptionDefinitions';
import { IOrderClause } from '../../../../ts/ServerApi/types/IOrderClause';

export const siteUserContentDefaultSortOrder: IOrderClause[] = [Order.asc(OrderKeys.name)];

export const siteUserContentSortOptions: OptionsDictionary = {
  // Mixed Content does not support relevance and owner sort does not make sense on the user space
  'name': SortOptions.name,
  'type': SortOptions.type,
  'updated': SortOptions.updated
};
